import Vue from 'vue'
import VueResource from 'vue-resource'
import Router from 'vue-router'
import LoginPage from '@/pages/login'
import ListingPage from '@/pages/listing'
import ItemEditPage from '@/components/ApiItemEdit'
import ItemNewPage from '@/components/ApiItemNew'
import ProfileEditPage from '@/pages/profile_edit'
import ProfileChangePasswordPage from '@/pages/profile_change_password'
import ProfileInvoicingDataPage from '@/pages/profile_invoicing_data'
import ProfileBackofficePreferencesPage from '@/pages/profile_preferences'
import ProfileAddressesPage from '@/pages/profile_addresses'
import Map from '@/pages/map'
import CompanyNewShippingPage from '@/pages/company_new'
import TourList from '@/components/TourList'
import ShippingListManual from '@/components/ShippingListManual'
import UserList from '@/components/UserList'
import CourierList from '@/components/CourierList'
import EventList from '@/components/EventList'
import FixedPriceList from '@/components/FixedPriceList'
import PwdResetEmail from '@/pages/password_email'
import PwdReset from '@/pages/password_reset'
import ViewTour from '@/pages/view_tour'
import ViewShipping from '@/pages/view_shipping'
import ViewUser from '@/pages/view_user'
import NewCompany from '@/pages/new_company'
import ViewCompany from '@/pages/view_company'
import ViewRole from '@/pages/view_role'
import NewCourier from '@/pages/new_courier'
import NewQuote from '@/pages/new_quote'
import BulkQuotes from '@/pages/bulk_quotes'
import BulkQuoteProviders from '@/pages/bulk_quote_providers'
import BulkQuote3p from '@/pages/bulk_quote_3p'
import EditBranding from '@/pages/view_branding'
import EditQuote from '@/pages/edit_quote'
import NewQuoteServices from '@/pages/new_quote_services'
import EditQuoteServices from '@/pages/edit_quote_services'
import NewItemPacks from '@/components/ItemPacksNew'
import NewWarehouse from '@/pages/new_warehouse'
import ViewWarehouse from '@/pages/view_warehouse'
import NewArea from '@/pages/new_area'
import ViewArea from '@/pages/view_area'
import NewRoutingZone from '@/pages/new_routing_zone'
import ViewRoutingZone from '@/pages/view_routing_zone'
import EditCountry from '@/components/CountryEdit'
import ShippingsSummary from '@/pages/summary'
import ControlPanel from '@/pages/control_panel'
import ControlPanelCod from '@/pages/control_panel_cod'
import IncidencesBy from '@/pages/incidences_by'
import IncidencesInWarehouse from '@/pages/incidences_in_warehouse'
import FlexesControl from '@/pages/flexes_control'
import IncidenceList from '@/components/IncidenceList'
import WhEntryMonitor from '@/pages/wh_entry_monitor'
import WhExitMonitor from '@/pages/wh_exit_monitor'
import WhIncidencesMonitor from '@/pages/wh_incidences_monitor'
import ToursControlMonitor from '@/pages/tours_control_monitor'
import B2bDocUpdate from '@/pages/b2b_doc_update'
import VehicleCapacity from '@/pages/vehicle_capacity'
import DownloadFromApi from '@/pages/download_from_api'
import TransactionList from '@/components/TransactionList'
import PendingAccountingNotesList from '@/components/PendingAccountingNotesList'
import RegionEditPage from '@/components/RegionEdit'
import vueAuthInstance from '@/services/auth'
import FleetRentalOrderList from '@/components/FleetRentalOrderList'
import FleetRentalOrderEdit from '@/components/FleetRentalOrderEdit'
import AiAddressReviewer from '@/pages/ai_address_reviewer'
import AiNegotiator from '@/pages/ai_negotiator'
import AiBulkAddressReview from '@/pages/ai_bulk_address_review'

import store from '@/store/index'
import NProgress from 'nprogress'

Vue.use(VueResource)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/list/shippings/manual'
    },
    {
      path: '/download/:url',
      name: 'downloadFromApi',
      component: DownloadFromApi,
      meta: { auth: true, title: 'New' },
      props: true
    },
    {
      path: '/ai/test-addresses',
      name: 'AiAddressReviewer',
      component: AiAddressReviewer,
      meta: { auth: true, title: 'New' },
      props: true
    },
    {
      path: '/ai/test-negotiation',
      name: 'AiNegotiator',
      component: AiNegotiator,
      meta: { auth: true, title: 'Negotiation v2 (JSON Mode)' },
      props: true
    },
    {
      path: '/ai/bulk-address-review',
      name: 'AiBulkAddressReview',
      component: AiBulkAddressReview,
      meta: { auth: true, title: 'Bulk Address Review' },
      props: true
    },
    {
      path: '/download/:url/:badLinkPart2/:badLinkPart3',
      name: 'downloadFromApiUrlRedirect',
      component: DownloadFromApi,
      meta: { auth: true, title: 'Download' },
      props: true
    },
    {
      path: '/download',
      name: 'downloadFromApiQuerystring',
      component: DownloadFromApi,
      meta: { auth: true, title: 'Download' }
    },
    {
      path: '/list/couriers',
      name: 'courierList',
      component: CourierList,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/list/events',
      name: 'eventList',
      component: EventList,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/list/fixed-prices',
      name: 'fixedPriceList',
      component: FixedPriceList,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/list/pending-accounting-notes',
      name: 'pendingAccountingNotes',
      component: PendingAccountingNotesList,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/summary',
      name: 'shippingsSummary',
      component: ShippingsSummary,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/control',
      name: 'controlPanel',
      component: ControlPanel,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/cod-control',
      name: 'controlPanelCod',
      component: ControlPanelCod,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/incidences-by',
      name: 'incidencesBy',
      component: IncidencesBy,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/flexes-control',
      name: 'flexesControl',
      component: FlexesControl,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: TransactionList,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/incidences',
      name: 'incidences',
      component: IncidenceList,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/incidences-in-warehouse',
      name: 'incidencesInWarehouse',
      component: IncidencesInWarehouse,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/monitor/entry',
      name: 'whEntryMonitor',
      component: WhEntryMonitor,
      meta: { fakeAuth: true, title: 'List' }
    },
    {
      path: '/monitor/exit',
      name: 'whExitMonitor',
      component: WhExitMonitor,
      meta: { fakeAuth: true, title: 'List' }
    },
    {
      path: '/monitor/incidences',
      name: 'whIncidencesMonitor',
      component: WhIncidencesMonitor,
      meta: { fakeAuth: true, title: 'List' }
    },
    {
      path: '/monitor/tours',
      name: 'toursControlMonitor',
      component: ToursControlMonitor,
      meta: { fakeAuth: true, title: 'List' }
    },
    {
      path: '/new/couriers',
      name: 'courierCreate',
      component: NewCourier,
      meta: { auth: true, title: 'New' },
      props: true
    },
    {
      path: '/edit/branding',
      name: 'EditBranding',
      component: EditBranding,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/new/quotes',
      name: 'quoteCreate',
      component: NewQuote,
      meta: { auth: true, title: 'New' },
      props: true
    },
    {
      path: '/bulk/quotes',
      name: 'quoteBulk',
      component: BulkQuotes,
      meta: { auth: true, title: 'Bulk' },
      props: true
    },
    {
      path: '/edit/quotes/:id',
      name: 'editQuote',
      component: EditQuote,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/new/quote-services',
      name: 'quoteServicesCreate',
      component: NewQuoteServices,
      meta: { auth: true, title: 'New' },
      props: true
    },
    {
      path: '/edit/quote-services/:id',
      name: 'editQuoteServices',
      component: EditQuoteServices,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/bulk/quote-providers',
      name: 'quoteProvidersBulk',
      component: BulkQuoteProviders,
      meta: { auth: true, title: 'Bulk' },
      props: true
    },
    {
      path: '/bulk/outsourcing-quotes',
      name: 'BulkQuote3p',
      component: BulkQuote3p,
      meta: { auth: true, title: 'Bulk' },
      props: true
    },
    {
      path: '/edit/countries/:id',
      name: 'editCountry',
      component: EditCountry,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/edit/regions/:id',
      name: 'editRegion',
      component: RegionEditPage,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { auth: false, title: 'Log in to your account' }
    },
    {
      path: '/profile/edit',
      name: 'profile-edit',
      component: ProfileEditPage,
      meta: { auth: true, title: 'Edit profile' }
    },
    {
      path: '/profile/change-password',
      name: 'profile-change-password',
      component: ProfileChangePasswordPage,
      meta: { auth: true, title: 'Change Password' }
    },
    {
      path: '/profile/invoicing-data',
      name: 'profile-invoicing-data',
      component: ProfileInvoicingDataPage,
      meta: { auth: true, title: 'Manage Invoicing Data' }
    },
    {
      path: '/profile/preferences',
      name: 'profile-preferences',
      component: ProfileBackofficePreferencesPage,
      meta: { auth: true, title: 'Manage your Backoffice Preferences' }
    },
    {
      path: '/profile/addresses',
      name: 'profile-addresses',
      component: ProfileAddressesPage,
      meta: { auth: true, title: 'Manage Addresses' }
    },
    // {
    //   path: '/users/',
    //   name: 'users',
    //   component: ListingPage,
    //   meta: { auth: true, title: 'Users' },
    //   props: { type: 'users' }
    // },
    {
      path: '/list/tours',
      name: 'tourList',
      component: TourList,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/edit/tours/:id',
      name: 'viewTour',
      component: ViewTour,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/edit/companies/:id',
      name: 'viewCompany',
      component: ViewCompany,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/new/companies/',
      name: 'newCompany',
      component: NewCompany,
      meta: { auth: true, title: 'New' }
    },
    {
      path: '/list/shippings/manual',
      name: 'shippingListManual',
      component: ShippingListManual,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/list/shippings', // DEPRECATED
      name: 'shippingList',
      redirect: '/list/shippings/manual',
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/edit/shippings/:id',
      name: 'viewShipping',
      component: ViewShipping,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/list/users',
      name: 'userList',
      component: UserList,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/list/vehicle-capacity',
      name: 'vehicleCapacityList',
      component: VehicleCapacity,
      meta: { auth: true, title: 'List' }
    },
    {
      path: '/edit/users/:id',
      name: 'viewUser',
      component: ViewUser,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/new/item-packs',
      name: 'newItemPacks',
      component: NewItemPacks,
      meta: { auth: true, title: 'Create' },
      props: true
    },
    {
      path: '/new/warehouses',
      name: 'newWarehouse',
      component: NewWarehouse,
      meta: { auth: true, title: 'Create' },
      props: true
    },
    {
      path: '/edit/warehouses/:id',
      name: 'viewWarehouse',
      component: ViewWarehouse,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/new/areas',
      name: 'newArea',
      component: NewArea,
      meta: { auth: true, title: 'Create' },
      props: true
    },
    {
      path: '/edit/areas/:id',
      name: 'viewArea',
      component: ViewArea,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/new/routing-zones',
      name: 'newRoutingZone',
      component: NewRoutingZone,
      meta: { auth: true, title: 'Create' },
      props: true
    },
    {
      path: '/edit/routing-zones/:id',
      name: 'viewRoutingZone',
      component: ViewRoutingZone,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/edit/roles/:id',
      name: 'viewRole',
      component: ViewRole,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/new/fleet-rental-orders',
      name: 'FleetRentalOrderNew',
      component: FleetRentalOrderEdit,
      meta: { auth: true, title: 'New' },
      props: true
    },
    {
      path: '/edit/fleet-rental-orders/:id',
      name: 'FleetRentalOrderEdit',
      component: FleetRentalOrderEdit,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/list/fleet-rental-orders',
      name: 'FleetRentalOrderList',
      component: FleetRentalOrderList,
      meta: { auth: true, title: 'List' },
      props: true
    },
    {
      path: '/list/:type',
      name: 'modelList',
      component: ListingPage,
      meta: { auth: true, title: 'List' },
      props: true
    },
    {
      path: '/edit/:type/:id',
      name: 'modelEdit',
      component: ItemEditPage,
      meta: { auth: true, title: 'Edit' },
      props: true
    },
    {
      path: '/new/:type',
      name: 'modelCreate',
      component: ItemNewPage,
      meta: { auth: true, title: 'New' },
      props: true
    },
    {
      path: '/shippings/',
      name: 'shippings',
      component: ListingPage,
      meta: { auth: true, title: 'Shippings' },
      props: { type: 'shippings' }
    },
    {
      path: '/map/',
      name: 'map',
      component: Map,
      meta: { auth: true, title: 'Map' }
    },
    {
      path: '/new-company-shipping',
      name: 'newCompanyShipping',
      component: CompanyNewShippingPage,
      meta: { auth: true, title: 'New shipping' }
    },
    {
      path: '/password/reset',
      name: 'password_email',
      component: PwdResetEmail,
      meta: { auth: false, title: 'Forgot Password' }
    },
    {
      name: 'password_reset',
      path: '/password/reset/:token',
      component: PwdReset,
      props: true,
      meta: { auth: false, title: 'Reset Password' }
    },
    {
      path: '/b2b-doc-update',
      name: 'b2b-doc-update',
      component: B2bDocUpdate,
      meta: { auth: true, title: 'B2B Doc Update' }
    }
  ]
})

// loadBar start
router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
    NProgress.set(0.1)
    NProgress.set(0.4)
  }
  next()
})
// loadBar end
router.afterEach((to, from) => {
  setTimeout(() => NProgress.done(), 500)
})

router.beforeEach(function (to, from, next) {
  if (to.meta && (to.meta.auth !== undefined || to.meta.fakeAuth)) {
    if (to.meta.auth || to.meta.fakeAuth) {
      if (vueAuthInstance.isAuthenticated()) {
        next()
      } else {
        store.commit('setUid', null)
        store.commit('setEmail', null)
        store.commit('setProfile', {})
        router.push({ name: 'login', query: { redirect: to.fullPath } })
      }
    } else {
      if (vueAuthInstance.isAuthenticated()) {
        router.push({ name: 'summary' })
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router
